/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Card } from 'primereact/card';
import { classNames } from 'primereact/utils';

interface CardSkeletonProps {
  variant?: 'full' | 'square' | 'text';
  className?: string;
  style?: React.CSSProperties;
}

export const CardSkeleton: React.FC<CardSkeletonProps> = ({ variant = 'full', className, style }) => {
  if (variant === 'square') {
    return (
      <Card className={classNames(className)} style={style}>
        <div className="flex flex-column gap-3">
          <Skeleton className="w-8rem h-1rem border-round" />
          <Skeleton className="w-full h-8rem border-round" />
          <Skeleton className="w-full h-1rem border-round" />
          <Skeleton className="w-full h-1rem border-round" />
          <Skeleton className="w-full h-8rem border-round" />
        </div>
      </Card>
    );
  }
  if (variant === 'text') {
    return (
      <div className="w-20rem">
        <Skeleton className="w-full h-1rem border-round" />
      </div>
    );
  }

  // Default: full rectangle
  return (
    <Card className={classNames(className)} style={style}>
      <Skeleton className="h-2rem w-full border-round" />
    </Card>
  );
};
